<template>
    <div
        v-if="content.heroBlocVideo.videoLink !== null"
        class="hero hero-video-fixed"
        role="banner"
    >
        <div class="video-wrapper">
            <video id="video-hero" class="hero-video" width="100%" height="auto" muted loop autoplay playsinline>
                <source :src="content.heroBlocVideo.videoLink" type="video/mp4" />
                <img
                    v-if="content.heroBlocVideo.videoPoster.url !== ''"
                    class="img-poster"
                    :src="content.heroBlocVideo.videoPoster.url"
                    :alt="content.heroBlocVideo.videoPoster.title"
                />
            </video>
        </div>

        <div
            v-if="content.heroBlocVideo.videoPoster.url !== ''"
            class="video-poster-wrapper bg-img"
            :style="{ backgroundImage: `url(${content.heroBlocVideo.videoPoster.url})` }"
        >

        </div>

        <div class="hero-content-fixed large-content d-flex align-items-start">
            <div v-if="content.heroBlocVideo.text !== null" class="container-fluid mt-auto">
                <div class="row">
                    <div class="col-12 col-xl-10 col-xxl-8 col-xxxl-6">
                        <div class="title-wrapper">
                            <h1
                                class="font-display split-text"
                                v-html="content.heroBlocVideo.text"
                            ></h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'HeroTexteBlocVideoSticky',

    // On loaded...
    mounted() {},

    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['content']),
    },
}
</script>
